import React from "react";

import _ from "lodash";

import Config from "../../constants/config";
import { Promise } from "bluebird";
import { reduceList, reduceListExtra } from "./utils.js";
import { setInterval } from "timers";

const twitch_base = "https://api.twitch.tv/kraken";
const channel_base = twitch_base + "/channels";
const stream_base = twitch_base + "/streams";
const subscribers_base = channel_id => `${channel_base}/${channel_id}/subscriptions?direction=desc`;
//const search_base = twitch_base + "/search/channels";

const withId = (url, hasQuery) =>
  url + (hasQuery ? "&" : "?") + "client_id=" + Config.twitch.client_id + "&api_version=5";
//const channelUrl = user => `${channel_base}/${user}`;
const streamUrl = channel_id => `${stream_base}/${channel_id}`;
//const searchUrl = channel => `${search_base}?query=${channel}`;
const getJson = res => res.json();
//const channel = user => fetch(withId(channelUrl(user))).then(getJson);
//const follows = user => fetch(withId(channelUrl(user) + "/follows")).then(getJson);
const stream = channel_id =>
  fetch(withId(streamUrl(channel_id)))
    .then(getJson)
    .then(s => s.stream);
//const search = channel => fetch(withId(searchUrl(channel), true)).then(getJson);
const channel = channelId => {
  const headers = new Headers();
  //headers.append("Authorization", "Oauth " + token);
  headers.append("Accept", "application/vnd.twitchtv.v5+json");
  headers.append("Client-ID", Config.twitch.client_id);
  //console.log("tt", fetch(withId(channel_base)));
  return fetch(channel_base + "/" + channelId, { method: "GET", headers: headers }).then(getJson);
};

const subs = (twitchId, token) => {
  var subHeaders = new Headers();
  subHeaders.append("Accept", "application/vnd.twitchtv.v5+json");
  subHeaders.append("Client-ID", Config.twitch.client_id);
  subHeaders.append("Authorization", `OAuth ${token}`);

  const opts = { method: "GET", headers: subHeaders };

  return fetch(subscribers_base(twitchId), opts)
    .then(r => r.json())
    .then(j => (j.error ? undefined : j));
};

const processChannel = json => {
  return {
    name: { type: "text", value: json.name },
    logo: { type: "image", value: json.logo },
    game: { type: "text", value: json.game },
    followers: { type: "number", value: json.followers },
    profile_banner: { type: "image", value: json.profile_banner },
    status: { type: "text", value: json.status || "Stream not started" },
    game_picture: {
      type: "image",
      value: "https://static-cdn.jtvnw.net/ttv-boxart/" + encodeURI(json.game) + "-272x380.jpg"
    }
  };
};

const processStream = stream => {
  return { viewers: { type: "number", value: stream.viewers } };
};

const defaultStream = { viewers: 0 };

const processSubs = subs => ({
  subCount: { type: "number", value: subs._total },
  subs: reduceList(subs.subscriptions, "_id", true)
});

const defaultSubs = {
  _total: 5,
  subscriptions: [
    {
      _id: 12,
      user: {
        display_name: "ExampleUser",
        logo: "http://localhost:3000/static/media/logo.e74d2999.svg"
      },
      sub_plan: "1000"
    },
    {
      _id: 13,
      user: {
        display_name: "FakeLirik",
        logo: "http://localhost:3000/static/media/logo.e74d2999.svg"
      },
      sub_plan: "2000"
    },
    {
      _id: 14,
      user: {
        display_name: "RealSoda",
        logo: "/static/media/logo.e74d2999.svg"
      },
      sub_plan: "1000"
    }
  ]
};

const getData = (params, id, cb) => {
  const twitchId = params.userId.split(":")[1];
  const token = _.get(params, "_tokens.twitch.access_token");
  Promise.all([stream(twitchId), channel(twitchId), subs(twitchId, token)]).then(
    ([str, chan, subz]) => {
      const processed = [
        processStream(str || defaultStream),
        processChannel(chan),
        processSubs(subz || defaultSubs)
      ];
      cb(
        processed.reduce((acc, r) => ({ ...acc, ...r }), {}),
        reduceListExtra(
          (subz && subz.subscriptions) || defaultSubs.subscriptions,
          "_id",
          s => ({
            user: { type: "text", value: s.user.display_name },
            sub_plan: { type: "text", value: s.sub_plan },
            userLogo: { type: "image", value: s.user.logo }
          }),
          "twitch.subs"
        )
      );
    }
  );
};

var looping = false;
var settings = undefined;
export default (params, id, cb) => {
  settings = [params, id, cb];
  if (!looping) {
    looping = true;
    getData(params, id, cb);
    setInterval(() => getData(settings[0], settings[1], settings[2]), 15000);
  }
};

/********************************** CLIPS *********************************
 * ************************************************************************
 * ************************************************************************/

const embed = id => `https://clips.twitch.tv/embed?clip=${id}`;

const clipId = url => {
  return url.split(".tv/")[1];
};

export const twitchEmbed = url => embed(clipId(url));

const iframeUrl = props => `${twitchEmbed(props.url)}&autoplay=true`;

export const TwitchClipComponent = props => (
  <iframe
    title="Twitch"
    style={props}
    frameBorder="0"
    src={iframeUrl(props)}
    onClick={e => {
      e.preventDefault();
      e.stopPropagation();
    }}
  />
);

//getChannel("427tcdmp8w4ot2bqu78suknpmnql85").then(r => console.log("WDUJWIUWD", r));

//token djoula
//fefwbj9c9xj819pc98x119vrojrpi5

//token yp3ds23daoriwaign7m09dpyigmapb
// const ws = new WebSocket("wss://pubsub-edge.twitch.tv");
// ws.onopen = _ => {
//   ws.send(JSON.stringify({ type: "PING" }));
//   ws.send(
//     JSON.stringify({
//       type: "LISTEN",
//       nonce: "44h1k13746815ab1r2",
//       data: {
//         topics: ["whispers.89127233"],
//         auth_token: "427tcdmp8w4ot2bqu78suknpmnql85"
//       }
//     })
//   );
//   ws.send(
//     JSON.stringify({
//       type: "LISTEN",
//       nonce: "44h1k13746815atoto",
//       data: {
//         topics: ["channel-subscribe-events-v1.41506705"],
//         auth_token: "fefwbj9c9xj819pc98x119vrojrpi5"
//       }
//     })
//   );
// };

//sub message
//

// var submsg = {
//   user_name: "iorekcsgo",
//   display_name: "iorekcsgo",
//   channel_name: "djoula",
//   user_id: "89127233",
//   channel_id: "41506705",
//   time: "2017-11-25T10:59:34.236614803Z",
//   sub_message: { message: "", emotes: null },
//   sub_plan: "1000",
//   sub_plan_name: "Channel Subscription (djoula)",
//   months: 0,
//   context: "sub"
// };

// ws.onmessage = e => {
//   console.log("ws data", JSON.parse(e.data));
// };



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/twitch.js